// src/components/common/MainNav.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';
import './MainNav.css';

export const MainNav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`trend-header-fixed ${scrolled ? 'scrolled' : ''}`}>
      {/* Logo */}
      <Link to="/" className="header-logo">
        <img src="/logo.webp" alt="K-B Logo" className="header-logo-img" />
        <span className="header-logo-text">Insight</span>
      </Link>

      {/* Language Selector */}
      <div className="header-actions">
        <LanguageSelector />
      </div>
    </header>
  );
};

export default MainNav;
